/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DxSelectBoxModule, DxButtonModule } from 'devextreme-angular';
import { SysqueFrameModule } from '../../../../../../../shared/ui/src/lib/components/sysque-frame';
import { ApplyPanelDataComponent } from './apply-panel-data.component';
import { RouterModule, Routes } from '@angular/router';
import { AlertModule } from '../../../../../../../shared/ui/src/lib/components/alert';

const routes: Routes = [{ path: 'dialog/apply-panel-data-dialog', component: ApplyPanelDataComponent }];

@NgModule({
  declarations: [ApplyPanelDataComponent],
  imports: [
    CommonModule,
    FormsModule,
    DxSelectBoxModule,
    DxButtonModule,
    SysqueFrameModule,
    AlertModule,
    RouterModule.forChild(routes),
  ],
  exports: [ApplyPanelDataComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ApplyPanelDataModule {}
